import { render, staticRenderFns } from "./CurrencyPicker.vue?vue&type=template&id=39ae2c09&"
import script from "./CurrencyPicker.vue?vue&type=script&lang=js&"
export * from "./CurrencyPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports